// extracted by mini-css-extract-plugin
module.exports = {"ProductTag":"ProductTag_ProductTag__oOg4S","isTicketBook":"ProductTag_isTicketBook__VLocV","isSubscription":"ProductTag_isSubscription__vPbLC"};